import { useState } from "react";
import { Play } from "lucide-react";

const KickStreamEmbed = () => {
  const [showStream, setShowStream] = useState(false);

  return (
    <section className="py-5 md:py-8 px-4">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-3xl font-bold text-foreground text-center mb-6">Watch Live</h2>

        <div className="relative rounded-xl overflow-hidden border border-primary/30 bg-card/50 backdrop-blur-sm shadow-lg">
          <div className="aspect-video">
            {showStream ? (
              <iframe
                src="https://player.kick.com/gamducks"
                className="w-full h-full"
                allowFullScreen
                title="GamDucks Kick Stream"
              />
            ) : (
              <button
                onClick={() => setShowStream(true)}
                className="w-full h-full flex flex-col items-center justify-center gap-4 bg-background/80 hover:bg-background/60 transition-colors cursor-pointer"
              >
                <Play className="w-16 h-16 text-primary fill-primary/20" />
                <span className="text-xl font-semibold text-foreground">Click to Watch Live</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default KickStreamEmbed;
